module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "geoPage"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "mask transparent"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('p', [_vm._v("正在定位中...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c751d32","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/map/GetLocation.vue
// module id = 832
// module chunks = 0